import { fetchUrl } from './fetchUrl';

type Theme = { css: string; id: string } | undefined;

export async function fetchTheme(themeId: string): Promise<Theme> {
    if (!themeId) {
        return;
    }

    return fetchUrl({
        endpoint: `/v2/checkout-themes/${themeId}`,
        method: 'GET',
        showCompleteResponse: true,
    });
}
